module.exports = __webpack_public_path__ + "static/media/venly.ec24c9bf.svg";